import * as React from "react";
const MinusSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 9 5 10 14 10 14 9z" }));
MinusSmall.displayName = "MinusSmall";
var MinusSmall_default = MinusSmall;
export {
  MinusSmall_default as default
};
